import type { TFunction } from '@if/core/i18n'
import * as yup from '@if/core/yup'
import { ControlledSearchField, FormContainer } from '@if/mui'
import { InteracWireSearchPossibleMatchFilters } from '@src/api/interac-wire-api'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const REFERENCE_NUMBER = /^[0-9]+$/

export const toSearchFilters = (query: string | null): InteracWireSearchPossibleMatchFilters | null => {
  const value = query?.trim()
  if (!value) return null
  const isReferenceNumber = REFERENCE_NUMBER.test(value)
  return { referenceNumber: isReferenceNumber ? value : null, email: isReferenceNumber ? null : value }
}

const buildSchema = (t: TFunction) =>
  yup.object({
    query: yup.text().test('is-email-or-reference', t('interacWire.searchByEmailOrReferenceError'), (value) => {
      const trimmed = value?.trim()
      if (!trimmed) return true
      return REFERENCE_NUMBER.test(trimmed) || yup.text().email().isValidSync(trimmed)
    }),
  })

interface InteracCandidateSearchFiltersProps {
  onChange: (filters: InteracWireSearchPossibleMatchFilters | null) => void
  loading?: boolean
}

const InteracCandidateSearchFilters = ({ onChange, loading }: InteracCandidateSearchFiltersProps) => {
  const { t } = useTranslation()
  const schema = useMemo(() => buildSchema(t), [t])

  return (
    <FormContainer
      mode="filters"
      useFormSetup={() => ({ schema })}
      onSubmit={(values) => onChange(toSearchFilters(values.query))}
    >
      {({ control }) => (
        <ControlledSearchField
          control={control}
          name="query"
          placeholder={t('interacWire.searchByEmailOrReference')}
          debounceTime={400}
          loading={loading}
          fullWidth
        />
      )}
    </FormContainer>
  )
}

export default InteracCandidateSearchFilters
